import { Component, OnInit } from "@angular/core";
import { DataService } from "../../../data.service";
import { DateUtils } from "../../../shared/date-utils";


@Component({
    selector: 'app-daily-distribution',
    templateUrl: './daily-distribution.component.html',
    styleUrls: ['./daily-distribution.component.css'],
    standalone: false
})

export class DailyDistributionComponent implements OnInit {
    period: any = new Date();

    options: any;
    data: any = null;
    dataLoading: boolean = false;

    constructor(private dataService: DataService) {

    }

    ngOnInit(): void {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        this.options = {
            indexAxis: 'y',
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        }
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                y: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
        
        this.showData();
    }

    showData() {
        this.data = null;
        this.dataLoading = true;

        const subscr = this.dataService.dailyDistributionStatistic(DateUtils.unixTimestamp(this.period)).subscribe({
            next: (data) => {
                const chartData: any[][] = [[],[]];
                let allNull = true;

                if (data && Array.isArray(data) && data.length > 0) {
                    const sorted = data.sort((a, b) => {
                        return a.status_id - b.status_id
                    });

                    sorted.forEach((item) => {
                        chartData[0].push(item.site);
                        chartData[1].push(item.app);

                        if (item.site > 0 || item.app > 0) {
                            allNull = false;
                        }
                    });

                    if (!allNull) {
                        this.data = {
                            labels: ['Добавлено', 'На складе', 'Отправлено', 'Прибыло', 'Вручено'],
                            datasets: [
                                {
                                    label: 'Сайт',
                                    // backgroundColor: documentStyle.getPropertyValue('--blue-500'),
                                    // borderColor: documentStyle.getPropertyValue('--blue-500'),
                                    data: chartData[0]
                                },
                                {
                                    label: 'Мобильное приложение',
                                    // backgroundColor: documentStyle.getPropertyValue('--blue-500'),
                                    // borderColor: documentStyle.getPropertyValue('--blue-500'),
                                    data: chartData[1]
                                },

                            ]
                        };
                    }
                }

                this.dataLoading = false;
            },
            error: (err) => {

            },
            complete: () => {
                subscr.unsubscribe();
                this.dataLoading = false;
            }
        });

    }

}